<template>
  <div class="section">
    <div class="container is-fullhd template-horizontal">
      <aside class="sidebar menu is-hidden-touch">
        <p class="menu-label">{{ $t("doc.key_concepts") }}</p>
        <ul class="menu-list">
          <li>
            <a href="#introduction">{{ $t("doc.introduction") }}</a>
          </li>
        </ul>
      </aside>
      <div class="docs-content">
        <h2 class="title">{{ $t("doc.key_concepts") }}</h2>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Docs'
  }
</script>

<style lang="scss" scoped>
  .template-horizontal {
    display: flex;
    flex-direction: row;
    flex: 1;
  }

  .sidebar {
    min-width: 16rem;
    padding-top: 3rem;
    padding-bottom: 3rem;
    padding-right: .5rem;
    position: sticky;
    top: 1rem;
    overflow: auto;
    max-height: calc(100vh - 2rem);
  }

  .docs-content {
    padding-left: 0;
    padding-top: 3rem;
    padding-bottom: 3rem;
    overflow: hidden;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Docs.vue